import SearchLinksSectionComponent from '@template/blocks/SearchLinksSection/component';
import { createComponent } from '@helpers/admin';

export const SearchLinks = createComponent({
  label: 'Search Links',
  component: SearchLinksSectionComponent,
  fields: {
    title: {
      label: 'Title',
      type: 'textarea',
    },
    links: {
      label: 'Links',
      type: 'array',
      arrayFields: {
        label: {
          label: 'Label',
          type: 'textarea',
        },
        placeholder: {
          label: 'Placeholder',
          type: 'textarea',
        },
        type: {
          label: 'Type',
          type: 'select',
          options: [
            {
              label: 'Number Purchase',
              value: 'number-purchase',
            },
            {
              label: 'Number Transfer',
              value: 'number-transfer',
            },
          ],
        },
        button: {
          label: 'Button',
          type: 'button',
        },
      },
    },
  },
});
